import { useMergeRefs } from '@floating-ui/react';
import React__default from 'react';
import { useModalState } from './use_modal_state.js';
import '../button/index.js';
import { Button } from '../button/button.js';

const ModalTrigger = React__default.forwardRef(function ModalTrigger({ children, ...rest }, propRef) {
    const { refs, getReferenceProps } = useModalState();
    const ref = useMergeRefs([refs.reference, propRef]);
    if (React__default.isValidElement(children)) {
        return React__default.cloneElement(children, getReferenceProps({
            ref,
            ...rest,
            ...children.props,
        }));
    }
    return (React__default.createElement(Button, { ref: ref, ...getReferenceProps(rest) }, children));
});

export { ModalTrigger };
